import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7ba41cbc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=7ba41cbc&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=7ba41cbc&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba41cbc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ba41cbc')) {
      api.createRecord('7ba41cbc', component.options)
    } else {
      api.reload('7ba41cbc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7ba41cbc&scoped=true", function () {
      api.rerender('7ba41cbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/messageNotice/index.vue"
export default component.exports